export default __webpack_public_path__ + "static/media/logo-color-w-text.3b548087.svg";